import { useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { useAuth } from '../AuthContext.jsx';
import { auth, signOut } from '../firebase.js';

const publicLinks = [
  { to: '/schedule', label: 'Schedule' },
  { to: '/shop', label: 'Shop' },
  { to: '/join', label: 'Join' },
  { to: '/rent', label: 'Rent clubhouse' },
];

export function Nav() {
  const { user, role } = useAuth();
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();

  const close = () => setOpen(false);

  return (
    <header className="sticky top-0 z-30 bg-canvas/85 backdrop-blur-lg border-b border-line">
      <div className="max-w-6xl mx-auto px-4 md:px-6 h-16 flex items-center justify-between">
        <Link to="/" onClick={close} className="flex items-baseline gap-2 group">
          <span className="font-display text-2xl font-semibold tracking-tight text-ink">Blaze</span>
          <span className="eyebrow text-brand hidden sm:inline">R.F.C.</span>
        </Link>

        <nav className="hidden md:flex items-center gap-1">
          {publicLinks.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              className={({ isActive }) =>
                `px-3 py-2 text-sm transition-colors ${
                  isActive ? 'text-ink font-medium' : 'text-ink-2 hover:text-ink'
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden md:flex items-center gap-2">
          {user ? (
            <>
              {(role === 'admin' || role === 'superadmin') && (
                <NavLink
                  to="/admin"
                  className={({ isActive }) =>
                    `btn-xs ${isActive || pathname.startsWith('/admin') ? 'bg-brand text-white' : 'bg-brand/10 text-brand-ink hover:bg-brand/15'}`
                  }
                >
                  Admin
                </NavLink>
              )}
              <NavLink to="/profile" className="btn-ghost btn-sm">
                Profile
              </NavLink>
              <button onClick={() => signOut(auth)} className="btn-outline btn-sm">
                Sign out
              </button>
            </>
          ) : (
            <>
              <Link to="/login" className="btn-ghost btn-sm">
                Sign in
              </Link>
              <Link to="/signup" className="btn-primary btn-sm">
                Join
              </Link>
            </>
          )}
        </div>

        <button
          onClick={() => setOpen(!open)}
          className="md:hidden h-10 w-10 -mr-2 flex flex-col items-center justify-center gap-[5px] text-ink"
          aria-label="Menu"
        >
          <span className={`h-[1.5px] w-5 bg-current transition-all ${open ? 'translate-y-[3px] rotate-45' : ''}`} />
          <span className={`h-[1.5px] w-5 bg-current transition-all ${open ? 'opacity-0' : ''}`} />
          <span className={`h-[1.5px] w-5 bg-current transition-all ${open ? '-translate-y-[3px] -rotate-45' : ''}`} />
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t border-line bg-canvas">
          <div className="px-4 py-5 flex flex-col">
            {publicLinks.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                onClick={close}
                className={({ isActive }) =>
                  `py-3 text-lg font-display ${isActive ? 'text-ink' : 'text-ink-2'}`
                }
              >
                {l.label}
              </NavLink>
            ))}
            <hr className="rule my-3" />
            {user ? (
              <>
                {(role === 'admin' || role === 'superadmin') && (
                  <NavLink to="/admin" onClick={close} className="py-3 text-lg font-display text-brand">
                    Admin
                  </NavLink>
                )}
                <NavLink to="/profile" onClick={close} className="py-3 text-lg font-display text-ink-2">
                  Profile
                </NavLink>
                <button
                  onClick={() => {
                    signOut(auth);
                    close();
                  }}
                  className="py-3 text-lg font-display text-ink-2 text-left"
                >
                  Sign out
                </button>
              </>
            ) : (
              <div className="flex gap-2 pt-2">
                <Link to="/login" onClick={close} className="btn-outline flex-1">
                  Sign in
                </Link>
                <Link to="/signup" onClick={close} className="btn-primary flex-1">
                  Join
                </Link>
              </div>
            )}
          </div>
        </div>
      )}
    </header>
  );
}
